import React from "react";
import {
  Box,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Table
} from '@material-ui/core';

export default class ComponentToPrint extends React.Component {
  render() {
    const searchValues = this.props.selectedSearchValues;
    const tableData = this.props.tableData;
    const TotalAmount = this.props.TotalAmount;

    const cellStyle = {
      border: '1px solid black',
      padding: '1px',
      fontSize: '0.9rem',
    };

    return (
      <div>
        <h2><center><u>Due Cheuqe Details Report</u></center></h2>
        <div>&nbsp;</div>
        <h3><center>Group : {searchValues.groupName}</center></h3>
        <h3><center>Factory : {searchValues.factoryName}</center></h3>
        <h3><center>Date : {(new Date(searchValues.selectedDate)).toLocaleDateString()}</center></h3>
        <div>&nbsp;</div>
        <Box minWidth={1050} display="flex" justifyContent="flex-end" p={2}>
          <TableContainer style={{ marginTop: 16, padding: 8, paddingBottom: '20px' }}>
            <Table size="small" aria-label="report table" style={{ borderCollapse: 'collapse', width: '100%' }}>
              <TableHead>
                <TableRow>
                  <TableCell style={{ fontWeight: "bold", border: "1px solid black", padding: "6px", width: 110 }} align="center">Voucher Number</TableCell>
                  <TableCell style={{ fontWeight: "bold", border: "1px solid black", padding: "6px", width: 110 }} align="center">Cheque Number</TableCell>          
                  <TableCell style={{ fontWeight: "bold", border: "1px solid black", padding: "6px", width: 130 }} align="center">Issuing Date</TableCell>
                  <TableCell style={{ fontWeight: "bold", border: "1px solid black", padding: "6px", width: 90 }} align="center">Due Date</TableCell>
                  <TableCell style={{ fontWeight: "bold", border: "1px solid black", padding: "6px", width: 130 }} align="center">Account</TableCell>
                  <TableCell style={{ fontWeight: "bold", border: "1px solid black", padding: "6px", width: 100 }} align="center">Recipient</TableCell>
                  <TableCell style={{ fontWeight: "bold", border: "1px solid black", padding: "6px", width: 120 }} align="center">Amount (Rs.)</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {tableData && tableData.map((item, idx) => (
                  <TableRow key={idx}>
                    <TableCell style={{ border: "1px solid black", padding: "6px", width: 130, fontWeight: 'bold' }} align="left">{item.voucherNumber}</TableCell>
                    <TableCell style={{ border: "1px solid black", padding: "6px", width: 130, fontWeight: 'bold' }} align="left">{item.chequeNumber}</TableCell>
                    <TableCell style={{ border: "1px solid black", padding: "6px", width: 110 }} align="center">{item.issuingDate ? (new Date(item.issuingDate)).toLocaleDateString() : "-"}</TableCell>
                    <TableCell style={{ border: "1px solid black", padding: "6px", width: 110 }} align="center">{item.dueDate ? (new Date(item.dueDate)).toLocaleDateString() : "-"}</TableCell>
                    <TableCell style={{ border: "1px solid black", padding: "6px", width: 90 }} align="left">{item.account}</TableCell>
                    <TableCell style={{ border: "1px solid black", padding: "6px", width: 130 }} align="left">{item.recipient}</TableCell>
                    <TableCell style={{ border: "1px solid black", padding: "6px", width: 100 }} align="right">{item.amount.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</TableCell>
                  </TableRow>
                ))}
              </TableBody>
              <TableRow style={{ border: '1px solid black' }}>
               <TableCell colSpan={6} align="left" style={{ border: '1px solid black' }}><b>Total</b></TableCell>
                <TableCell align={'right'} component="th" scope="row" style={{ border: '1px solid black' }}>
                  <b>
                    {(TotalAmount && TotalAmount.amount != null)
                      ? TotalAmount.amount.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })
                      : "0.00"}
                  </b>
                </TableCell>
              </TableRow>
            </Table>
          </TableContainer>
        </Box>
        <div>&nbsp;</div>
      </div>
    );
  }
}